export const sliderItems = [{
    id:1,
    img:"https://i.ytimg.com/vi/97t_VdPFOAQ/maxresdefault.jpg",
    title:"CALL OF DUTY HARDLOCK",
    desc:"Hottest online first person shooter, Playstation game of the year",
    bg:"fcf1ed",
},{
    id:2,
    img:"https://compass-ssl.xbox.com/assets/a6/d4/a6d4d7dc-63a1-4aea-b0ad-c27de18f4507.jpg?n=Halo_Content-Placement-0_Halo-5_788x444.jpg",
    title:"HALO V",
    desc:"Online Xbox multiplayer first person shooter, fan favorites ",

    bg:"f5fafafd",
},{
    id:3,
    img:"https://cdn.akamai.steamstatic.com/steam/apps/1172540/capsule_616x353.jpg?t=1574816940",
    title:"STREET FIGHTER V",
    desc:"Go mano y mano combat with the latest reboot classic",
    bg:"f0fbfe",
}];

export const categories = [{
    id:1,
    img:"https://www.nintendo.com//content/dam/noa/en_US/games/switch/n/new-super-mario-bros-u-deluxe-switch/new-super-mario-bros-u-deluxe-switch-hero.jpg",
    title:"SUPER MARIO BROS DELUX",
    cat:"RPG"
},{
    id:2,
    img:"https://upload.wikimedia.org/wikipedia/en/5/5a/FF_XV_cover_art.jpg",
    title:"FINAL FANTASY XV",
    cat:"RPG"
},{
    id:3,
    img:"https://gamegator.net/thumbnails/blog-gears-5-small.jpg",
    title:"GEARS 5",
    cat:"TPS"
}];

export const popularProducts = [
    {
      id:1,
      img:"https://cheapestgamestore.com/wp-content/uploads/2021/09/045496428099.jpg",
    },
    {
      id:2,
      img:"https://cdn-products.eneba.com/resized-products/3oSjLWh0PD7mPzjw-dH8E2U4LpvCc4Bh3sbfmHABsWY_350x200_3x-0.jpeg",
    },
    {
      id:3,
      img:"https://smartcdkeys.com/image/cache/catalog/image/cache/data/products/nba-2k22/cover/nba-2k22-nba-75th-anniversary-edition-smartcdkeys-cheap-cd-key-cover-390x580.webp",
    },
    {
      id:4,
      img:"https://images-na.ssl-images-amazon.com/images/I/91jJUxI6RFL.jpg",
    },
    {
      id:5,
      img:"https://ssb.wiki.gallery/images/thumb/1/15/Super_Smash_Bros_Ultimate_Box_Art.png/250px-Super_Smash_Bros_Ultimate_Box_Art.png",
    },
    {
      id:6,
      img:"https://images.lukiegames.com/t_300e2/assets/images/Wii/WII_NEW_SUPER_MARIO_BROS_WII.jpg",
    },
    {
      id:7,
      img:"https://cdn11.bigcommerce.com/s-ymgqt/images/stencil/300x300/products/45569/39671/zelda-breath__33722.1626109236.jpg?c=2",
    },
    {
      id:8,
      img:"https://www.adorama.com/images/300x300/so3006168.jpg",
    },
  ]